import { appItem } from '@/mocks/home';

export default function SectionApp() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              移动观影
            </h2>
          </div>

          <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center gap-8 p-6 md:p-10">
              <div className="flex-1 w-full lg:w-auto text-center lg:text-left">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-4">
                  {appItem.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed max-w-lg mb-6">
                  {appItem.desc}
                </p>
                <div className="flex flex-wrap gap-2 justify-center lg:justify-start mb-6">
                  {appItem.features.map((feat) => (
                    <span
                      key={feat}
                      className="px-3 py-1.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap"
                    >
                      {feat}
                    </span>
                  ))}
                </div>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line"></i>
                  体验移动端
                </a>
              </div>

              <div className="w-full max-w-[240px] lg:max-w-[260px] shrink-0">
                <div className="relative aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-200/60 shadow-lg">
                  <img
                    src={appItem.image}
                    alt="777影院移动端"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}